import core from '@gin-betting/core';
import { useSelector } from 'react-redux';

import { State } from 'types';
import { BettingWidgets } from 'app-constants';
import { useWidgetSettings } from 'hooks';

interface Output {
    isVisible: boolean;
    isStreamPinAvailable: boolean;
}

const {
    viewport: {
        selectors: { makeViewportSelector },
    },
} = core;

const lessThenOrEqualSelector = makeViewportSelector('lessThanOrEqual');

function useLeftSidebar(): Output {
    const { containerElementId } = useWidgetSettings({
        widget: BettingWidgets.CATEGORIZER,
    });

    const { pinMinimizedStreamOutOfView } = useWidgetSettings({
        widget: BettingWidgets.STREAM,
    });

    const isTablet = useSelector((s: State) => lessThenOrEqualSelector(s, {}))
        .medium;

    return {
        isStreamPinAvailable: !!pinMinimizedStreamOutOfView,
        isVisible: containerElementId ? true : !isTablet,
    };
}

export default useLeftSidebar;
